import { render, staticRenderFns } from "./OnboardingVerificationPrompt.vue?vue&type=template&id=0efac4a0&"
import script from "./OnboardingVerificationPrompt.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports